import dayjs from 'dayjs';
import { FormInstance } from 'components/index';
import { useParams } from 'react-router-dom';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTaskByIdQuery, useTaskDetailsUpdateMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { ITaskDetailsUpdate } from 'components/common/tasks/general/taskInfo/edit/index';

export const useTaskDetailsEdit = (props: { form: FormInstance } & ITaskDetailsUpdate) => {
  const { id, onCancel, form, entity, open } = props;
  const { id: entityId } = useParams() as { id: string };
  const { data: taskDetails = {} } = useTaskByIdQuery({ id });
  const [isSaveBtnDisabled, setIsSaveBtnDisabled] = useState(true);
  const { handleError, handleSuccess } = useNotificationMessages();

  const [updateTaskDetails, { isLoading: detailsUpdateIsLoading }] = useTaskDetailsUpdateMutation();

  const onCancelModal = useCallback(() => {
    form.resetFields();
    setIsSaveBtnDisabled(true);
    onCancel();
  }, [form, onCancel]);

  const initialValues = useMemo(() => {
    return {
      assignedTo: taskDetails.assignedTo,
      priorityLevel: taskDetails.priorityLevel,
      dueDate: dayjs(taskDetails.dueDate),
    };
  }, [taskDetails]);

  useEffect(() => {
    if (open) {
      form.setFieldsValue(initialValues);
    }
  }, [open, form, initialValues]);

  const onFinish = useCallback(async () => {
    try {
      const payload = form.getFieldsValue();
      payload.id = id;
      payload.entityType = entity;
      payload.entityId = entityId;
      const { data, error }: any = await updateTaskDetails(payload);
      if (data?.success) {
        handleSuccess('The task details were successfully updated.');
        onCancelModal();
      } else {
        handleError(error);
      }
    } catch (err) {
      handleError(err);
    }
  }, [updateTaskDetails, handleError, handleSuccess, onCancelModal, id, entityId, entity, form]);

  return {
    onFinish,
    isSaveBtnDisabled,
    onCancelModal,
    isLoading: detailsUpdateIsLoading,
  };
};
